import React from 'react';
import { formatValue, formatPercent } from '../shared/chartTheme.js';
import '../../styles/DashboardComponents.css';

// Coût de l'eau du bâtiment : total, barre empilée froid/chaud et une ligne par part.
// Remplace l'ancien donut (WaterUsagePieChart), trop petit dans l'encadré pour y loger
// le total. Bleu pétrole = froid, orange corail = chaud (teintes de la palette des graphiques).
const PARTS = [
    { key: 'cold', label: 'Eau froide', color: '#205673' },
    { key: 'hot', label: 'Eau chaude', color: '#eb7246' },
];

const WaterCostBreakdown = ({ coldCost, hotCost }) => {
    const values = { cold: coldCost || 0, hot: hotCost || 0 };
    const total = values.cold + values.hot;
    const share = (value) => (total > 0 ? (value / total) * 100 : 0);

    return (
        <div className="water-cost-breakdown">
            <div className="water-cost-breakdown-total">
                <strong>{formatValue(total)} €</strong>
                <span>par an</span>
            </div>
            <div className="water-cost-breakdown-bar" role="img" aria-label="Répartition eau froide / eau chaude">
                {PARTS.map((part) =>
                    values[part.key] > 0 ? (
                        <span key={part.key} style={{ width: `${share(values[part.key])}%`, background: part.color }} />
                    ) : null
                )}
            </div>
            <ul className="water-cost-breakdown-rows">
                {PARTS.map((part) => (
                    <li key={part.key}>
                        <span className="water-cost-breakdown-dot" style={{ background: part.color }} />
                        <span className="water-cost-breakdown-label">{part.label}</span>
                        <span className="water-cost-breakdown-value">{formatValue(values[part.key])} €</span>
                        <span className="water-cost-breakdown-percent">{formatPercent(share(values[part.key]), true)}%</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default WaterCostBreakdown;
